import React, { useEffect, useRef } from "react";
import NailaChat from "naila-chat-sdk";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

export default function AIAssistant() {
  const { token } = useAuth();
  const chatRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    const chat = NailaChat.init({
      src: "https://naila-ai.invexonline.com/embed",
      token,
      // Optional: send user info
      // getCurrentUser: async () => ({
      //   id: "123",
      //   name: "Jane Doe",
      //   email: "jane@example.com",
      // }),
    }).onMessage((data) => {
      if (data?.type === "naila-quicklink-action") {
        const action = data?.action;
        if (action?.type === "open" && action?.link) {
          navigate(action?.link);
        }
      }
    });

    chatRef.current = chat;

    // Cleanup on unmount
    return () => {
      chat?.destroy?.();
    };
  }, [token]);

  return <div ref={chatRef} />;
}
